import { useFormContext } from 'react-hook-form';
import { useMutation } from 'react-query';
import { useLocation, useParams } from 'react-router-dom';

import { thankYouPage } from 'app/translations/dictionary';
import { fileUploaderService } from 'pkg/components/FileUploader/fileUploaderService';
import { useContext } from 'react';
import { UserContext } from 'app/modules/Context';

export const useFileRejection = () => {
  const location = useLocation();
  const formContext = useFormContext<{ name: string; email: string }>();
  const { id } = useParams<{ id?: string }>();
  const { mutate } = useMutation(fileUploaderService.sendRejectionMessage);
    const { user } = useContext(UserContext);

  return (fileNames: string[]) => {
    const { name, email } = formContext ? formContext.getValues() : {email: user?.email || '', name: user?.name || ''};
    mutate({
      fileExtensions: fileNames,
      quoteId: id ? String(id) : undefined,
      name: typeof name === 'string' ? name : undefined,
      email: typeof email === 'string' ? email : undefined,
      serviceName: Object.entries(thankYouPage.serviceType).find(([key]) => location.pathname.includes(key))?.[1] ?? '',
    });
  };
};
